import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo, useRef, useCallback } from "react";
import {
  setTheProfileSignatureActions,
  SetUserREtrieveActions,
  SetSignaturePops,
  SetChangedUrl,
  setTheProfileSignatureEDITActions,
  setTheSignaturePadNumberSet,
  setThePresentUrlsSended,
  setThepresentUrlOfSignature
} from "../../../Redux/Slice";
import Webcam from "react-webcam";
import Modal from "react-modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../StyleSheet/MainComponent/Userprofile.scss";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import sing from "../../../Assets/signature-required-2C3A7TG.jpg";
import axios from "axios";
import { PresentUrl } from "../../../text/apidata";
import { store } from "../../../Redux/Store";
import ImageCropper from "../ReactcropOverall/Imagecrop";
import NotificationScreen from "./Notificationscree";
import { Bell, Eye, EyeOff } from "lucide-react";

const UserProfilepart = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );

  const UserObjectData = useSelector((state) => state.users.UserData);
  const createnewuser = {
    first_name: "",
    email: "",
    phone_number: "",
    last_name: "",
  };
  const fileInputRef = useRef()
  const [data, setData] = useState(createnewuser);
  const [UserID, setUserID] = useState("");
  const [ManagerSign, SetManagerSign] = useState(false);
  const [Img, setImg] = useState(null);
  const [img, setimg] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [CroppImageView, setCroppImageView] = useState(false);
  const [UserFile, setUserFile] = useState()

  const [FILE, setImgFile] = useState(null);
  const [FileTrue, setFileTrue] = useState(false);
  const Signature = {
    signature: "",
  };
  const [Signs, setSign] = useState(Signature);
  const form_data = new FormData();
  const [showWebcam, setShowWebcam] = useState(false);
  const webcamRef = useRef(null);
  const [signed, setsigned] = useState(false);
  const RoleBased = useSelector((state) => state.SideBarFiles.NameRoles);
  const [RegionMap, setRegionMap] = useState([]);
  const [userdata, setuserdata] = useState({
    state: "",
    region: "",
    zone: "",
  });
  const [notifiycationpopup, setnotificationpopus] = useState(false)
  const [aadharAccess, setAadharAccess] = useState(
    localStorage.getItem("aadharAccess") === "true"
  );

  ///---present---url
  const [PresentUrls, setPresentUrls] = useState([]);
  const [presenturlInUrl, seturlandfile] = useState({
    file: "",
    url: ""
  })

  useEffect(() => {
    if (state.users.UserData.data != undefined) {
      if (UserObjectData.session) {
        var udsroleSelectedstate;
        var zoneselact;
        var regionsSelect;
        if (UserObjectData.data) {
          setUserID(UserObjectData.data.id);
        }

        let RegionLabels = [];
        if (UserObjectData.data.state_id.length > 0) {
          UserObjectData.data.state_id.map((item, index) => {
            if (index == 0) {
              udsroleSelectedstate = {
                value: item.id,
                label: item.state_name,
              };
            }
          });
        }

        if (UserObjectData.data.state_id.length == 0) {
          udsroleSelectedstate = { value: "", label: "" };
        }

        if (UserObjectData.data.zone_id.length > 0) {
          UserObjectData.data.zone_id.map((item, index) => {
            if (index == 0) {
              zoneselact = {
                value: item.id,
                label: item.zone_name,
              };
            }
          });
        }

        if (UserObjectData.data.region_id.length > 0) {
          UserObjectData.data.region_id.map((item, index) => {
            RegionLabels.push({ label: item.region_name });
            if (index == 0) {
              regionsSelect = {
                value: item.id,
                label: item.region_name,
              };
            }
          });
        }
        if (UserObjectData.data.zone_id.length == 0) {
          zoneselact = { value: "", label: "" };
        }
        if (UserObjectData.data.region_id.length == 0) {
          regionsSelect = { value: "", label: "" };
        }

        setRegionMap(RegionLabels);
        setuserdata({
          ...userdata,
          state: udsroleSelectedstate.label,
          region: regionsSelect.label,
          zone: zoneselact.label,
        });
      }
    }
  }, [UserObjectData]);


  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
    const maxSize = 3 * 1024 * 1024; // 3MB in bytes

    if (file && allowedTypes.includes(file.type)) {
      if (file.size > maxSize) {
        toast.error("File size exceeds 3MB. Please upload a smaller image.");
      } else {
        const reader = new FileReader();
        reader.onload = (e) => { };
        reader.readAsDataURL(file);
        setImgFile(file);
        setUserFile(event)
        setFileTrue(true);
        setCroppImageView(true)
      }
    } else {
      toast.error("Please upload an image file (jpg, jpeg, png, svg).");
    }
  };

  const updateAvatar = (imgSrc) => {
    fileInputRef.current = imgSrc;
  };
  const handleCameraClick = () => {
    setIsModalOpen(true);
  };

  const capturePhoto = useCallback(() => {
    setPresentUrls([]);
    const imageSrc = webcamRef.current.getScreenshot();
    setimg(imageSrc);
    const file = dataURLtoFile(imageSrc, "webcam_photo.jpg");
    setImgFile(file);

    const generateRandomNumber = (digits = 12) => {
      const min = 10 ** (digits - 1);
      const max = 10 ** digits;
      return Math.floor(min + Math.random() * (max - min));
    };

    const createPresentData = (file) => {
      const randomNumber = generateRandomNumber();
      const formattedFilename = `onboarding/user_image/user_image${randomNumber}.${file.type.split('/')[1]}`; // Use the file's extension
      const Presentdata = {
        multiple_files: [
          {
            filename: formattedFilename,
            file_type: file.type,
          },
        ],
      };

      return Presentdata;
    };



    const Presentdata = createPresentData(file);

    axios({
      url: PresentUrl,
      method: 'post',
      data: Presentdata,
      headers: {
        Authorization:
          "Bearer " + store.getState().users.UserData.session.token,
      },
    })
      .then((response) => {
        const uploadedFiles = response.data.data;
        const newUrls = uploadedFiles.map(urls => ({
          url: urls,
          type: file.type,
          putfiles: file

        }));

        setPresentUrls(prevUrls => [...prevUrls, ...newUrls]);
        seturlandfile({
          url: String(response.data.data).split("?")[0]
        })
      })
      .catch((error) => {
        console.error('Error uploading files:', error);
      });



    setIsModalOpen(false);
    setFileTrue(true);
  }, [webcamRef]);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  ////---___Signature-----Popup---------------------
  const [SignaturePopups, setSignaturePopup] = useState(false);

  useEffect(() => {
    if (state.users.UserData.data != undefined) {
      if (UserObjectData.session) {
        // setUserID(UserObjectData.data.id);
        const payload = {
          EditId: UserObjectData.data.id,
        };
        dispatch(SetUserREtrieveActions(payload));
      }
    }
  }, [state.users.UserData]);
  useEffect(() => {
    if (
      state.UserRetrieve != undefined &&
      state.UserRetrieve.userRetrireve.id == UserID &&
      state.UserRetrieve.userRetrireve.id != undefined &&
      state.UserRetrieve.userRetrireve.id != undefined &&
      state.UserRetrieve.userRetrireve.state_id != undefined &&
      state.UserRetrieve.userRetrireve.region_id != null &&
      state.UserRetrieve.userRetrireve.region_id != []
    ) {
      setData({
        ...data,
        first_name: state.UserRetrieve.userRetrireve.first_name,
        last_name: state.UserRetrieve.userRetrireve.last_name,
        email: state.UserRetrieve.userRetrireve.email,

        phone_number:
          state.UserRetrieve.userRetrireve.phone_number != null
            ? state.UserRetrieve.userRetrireve.phone_number
            : "",
      });

      if (
        state.UserRetrieve.userRetrireve.user_sign_image != undefined &&
        state.UserRetrieve.userRetrireve.user_sign_image != null &&
        state.UserRetrieve.userRetrireve.user_sign_image.media_url != undefined
      ) {
        setImg(state.UserRetrieve.userRetrireve.user_sign_image.media_url);
        setSign({
          ...Signs,
          signature: state.UserRetrieve.userRetrireve.user_sign_image.media_url,
        });
        dispatch(setThepresentUrlOfSignature(state.UserRetrieve.userRetrireve.user_sign_image.media_url))
      }

      if (
        state.UserRetrieve.userRetrireve.user_image != undefined &&
        state.UserRetrieve.userRetrireve.user_image != null &&
        state.UserRetrieve.userRetrireve.user_image.media_url != undefined
      ) {
        seturlandfile({
          ...presenturlInUrl,
          ur: state.UserRetrieve.userRetrireve.user_image.media_url
        })
        setimg(state.UserRetrieve.userRetrireve.user_image.media_url);
      }



      if (
        state.UserRetrieve.userRetrireve.user_sign_image == undefined ||
        state.UserRetrieve.userRetrireve.user_sign_image == null ||
        state.UserRetrieve.userRetrireve.user_sign_image.media_url == undefined
      ) {
        dispatch(setThepresentUrlOfSignature(""))
      }


    }
  }, [state.UserRetrieve.userRetrireve.id]);


  function getCroppedImg(imageRef, crop, fileName) {
    setPresentUrls([])
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imageRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );



    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }
        const croppedFile = new File([blob], fileName, {
          type: "image/jpeg",
        });
        var file = croppedFile;
        if (croppedFile) {
          setTimeout(() => {
            setCroppImageView(false)

          }, 0);



          const generateRandomNumber = (digits = 12) => {
            const min = 10 ** (digits - 1);
            const max = 10 ** digits;
            return Math.floor(min + Math.random() * (max - min));
          };

          const createPresentData = (croppedFile) => {
            const randomNumber = generateRandomNumber();
            const formattedFilename = `onboarding/user_image/user_image${randomNumber}.${croppedFile.type.split('/')[1]}`; // Use the file's extension
            const Presentdata = {
              multiple_files: [
                {
                  filename: formattedFilename,
                  file_type: croppedFile.type,
                },
              ],
            };

            return Presentdata;
          };



          const Presentdata = createPresentData(croppedFile);

          axios({
            url: PresentUrl,
            method: 'post',
            data: Presentdata,
            headers: {
              Authorization:
                "Bearer " + store.getState().users.UserData.session.token,
            },
          })
            .then((response) => {
              console.log('Files uploaded successfully:', response.data);
              const uploadedFiles = response.data.data;
              const newUrls = uploadedFiles.map(file => ({
                url: file,
                type: croppedFile.type,
                putfiles: croppedFile

              }));

              // Update PresentUrls state
              setPresentUrls(prevUrls => [...prevUrls, ...newUrls]);
              seturlandfile({
                url: String(response.data.data).split("?")[0]
              })
            })
            .catch((error) => {
              console.error('Error uploading files:', error);
            });

        }

        var file = croppedFile;
        var reader = new FileReader();

        reader.onloadend = function () {
          setimg(reader.result)
        };
        reader.readAsDataURL(file);
        resolve(croppedFile);
      }, "image/jpeg");
    });
  }

  const HandelPopup = () => {
    setSignaturePopup(!SignaturePopups);
    dispatch(setTheSignaturePadNumberSet(1));
    dispatch(SetSignaturePops(!SignaturePopups));
    setsigned(true);
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const validateEmail = (email) => {
    return emailRegex.test(email);
  };

  const HandleClick = (e) => {
    var a = 0;


    const fetchUploadFiles = async () => {
      await Promise.all(state.signaturepad.PresentFullURL.map(async (item) => {
        try {
          const response = await fetch(item.url, {
            method: 'PUT',
            headers: {
              'Content-Type': item.type,
              "x-amz-acl": "public-read"
            },
            body: item.putfiles,
          });
          dispatch(setThePresentUrlsSended(false))
        } catch (error) {
          console.error('Error uploading files:', error);
        }
      }));
    }


    const fetchUploadUserImage = async () => {
      await Promise.all(PresentUrls.map(async (item) => {
        try {
          const response = await fetch(item.url, {
            method: 'PUT',
            headers: {
              'Content-Type': item.type,
              "x-amz-acl": "public-read"
            },
            body: item.putfiles,
          });
          setFileTrue(false);

          const data = await response.json();

          console.log('Files uploaded successfully:', data);
        } catch (error) {
          console.error('Error uploading files:', error);
        }
      }));
    }

    form_data.append("data", JSON.stringify({}));
    if (FileTrue) {
      form_data.append("user_image", FILE);
    }

    if (FileTrue) {
      fetchUploadUserImage()

    }

    if (a == 0 && state.signaturepad.PresentUrlsSended == true) {
      fetchUploadFiles();

    }

    if (a == 0) {
      if (signed && state.signaturepad.ChangesURl == 2) {
        dispatch(SetChangedUrl(1));
      }

      const payload = {
        form_data: {
          sign: state.signaturepad.PresentURL,
          user_image: presenturlInUrl.url
        },
        EditId: UserID,
      };
      dispatch(setTheProfileSignatureEDITActions(payload));
    }
  };

  useEffect(() => {
    if (UserID != undefined) {
      if (state.signaturepad.ChangesURl == 2) {
        setImg(state.signaturepad.fileName);
        setSign({
          ...Signs,
          signature: state.signaturepad.fileName,
        });
      }
    }
  }, [state.signaturepad.fileName, state.signaturepad.ChangesURl]);

  function dataURLtoFile(dataurl, filename) {
    // Decode the data URL
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };


  return (
    <>
      <div
        className={stateDisplay ? "outterContent" : "inner-Content"}
        style={{ padding: "20px" }}
      >

        <div className="card profile-card">
          <div className="card-header  text-black HeaderOF UserProfileDatas">
            <p className="UserDetails">Profile</p>
            <div className="d-flex align-items-center containerParts">
              <div className="InnerProfileImg">
                {/* <Bell className="BellIconsNotifify" onClick={() => { setnotificationpopus(!notifiycationpopup) }} /> */}

                <div
                  className="Image"
                  style={{
                    width: "200px",
                    height: "200px",
                    border: "1px solid #ddd",
                    borderRadius: "50%",
                  }}
                >
                  {img ? (
                    <img
                      src={img}
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                      }}
                      onClick={(e) => {
                        window.open(img)
                      }}
                    />
                  ) : (
                    <img
                      src={profile2}
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                      }}
                    />
                  )}
                </div>
                <div>
                  <button
                    className="Signatures CamBtn"
                    onClick={handleCameraClick}
                    style={{
                      marginTop: "20px",
                      background: "#234492",
                      marginRight: "10px",
                      color: "#ffff !important",
                      // background: "none",
                    }}
                  >
                    Camera
                  </button>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileUpload}
                    style={{ display: "none" }}
                    id="file-upload"
                    ref={fileInputRef}
                  />
                  <label
                    htmlFor="file-upload"
                    className="Signatures CamBtn"
                    style={{
                      marginTop: "20px",
                      background: "#234492",
                      color: "#ffff !important",
                      cursor: "pointer",
                      // background: "none",
                    }}
                  >
                    Upload
                  </label>

                </div>
              </div>

              <div className="RightSideField">
                <p
                  // className="NameField"
                  className="ProfileNames"
                  style={{ width: "100%", marginBottom: "0px" }}
                >
                  <span>Name:</span>
                  {capitalizeFirstLetter(data.first_name)}
                </p>
                <p
                  className="ProfileNames"
                  style={{ width: "100%", marginBottom: "0px" }}
                >
                  <span>Designation:</span>
                  <span> {`  ${capitalizeFirstLetter(RoleBased)}`}</span>
                </p>

                <p className="ProfileNames" style={{ width: "100%" }}>
                  <span>Email:</span>
                  <span> {`  ${data.email}`}</span>
                </p>

                {/* 
                <p className="mb-0 ProfileNames" style={{ width: "100%" }}>
                  {
                  state.ClientBranchIDs.SUBROLE != 3 && 
                  RegionMap.length > 0 
                  
                  ? (
                    <>
Region:


                      <span> {`${RegionMap.map((item)=>( 
                        item.label

                      )
                      )}`}</span>
                    </>
                  ) : null}
                </p> */}

                {data.phone_number != "" ? (
                  <p className="mb-0 ProfileNames" style={{ width: "100%" }}>
                    <span>Phone Number:</span>
                    <span> {`  ${data.phone_number}`}</span>
                  </p>
                ) : null}

                <button
                  className="btn ButtonCSS"
                  onClick={(e) => {
                    const newAccess = !aadharAccess;
                    setAadharAccess(newAccess);
                    localStorage.setItem("aadharAccess", String(newAccess));
                  }}
                  style={{
                    marginTop: "10px",
                    background: "#234492",
                    marginLeft: "226px",
                    color: "#ffff  !important",
                    fontWeight: "100",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  {aadharAccess ? <EyeOff size={16} /> : <Eye size={16} />}
                  {aadharAccess ? "Hide Aadhar" : "Show Aadhar"}
                </button>
              </div>
            </div>
          </div>
          <div
            className="card-body CardBodySignature"
            style={{
              background: "#fff",
              width: "100%",
              display: "flex",
              gap: "140px",
              padding: "18px 55px",
            }}
          >
            <div className="d-flex  mb-3 row" style={{ height: "373px" }}>
              <div className="col-6" style={{ height: "286px" }}>
                <label
                  class="form-label"
                  style={{
                    fontWeight: "800",
                    width: "100%",
                    margin: "21px 0px",
                    fontSize: "23px",
                  }}
                >
                  Signature
                </label>
                <div
                  className="Image"
                  style={{
                    // width: "200px",
                    // height: "200px",
                    height: "246px",
                    width: "390px",
                    border: "1px solid #ddd",
                    background: "#ffff",
                  }}
                >
                  {Img != null && Img != "" && Img != undefined ? (
                    <img
                      src={Img}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  ) : (
                    <img
                      src={sing}
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  )}

                  <button
                    class="btn ButtonCSS"
                    onClick={(e) => {
                      HandelPopup(e);
                    }}
                    style={{
                      marginTop: "10px",
                      // marginTop:"255px",
                      background: "#234492",
                      marginLeft: "226px",
                      color: "#ffff  !important",
                      fontWeight: "100",
                    }}
                  >
                    Click here to sign
                  </button>
                </div>
              </div>
            </div>

          </div>

          {FileTrue || signed ? (
            <div
              className="card-body CardBodySignature"

            >
              <div className=" row" style={{ width: "100%" }}>
                <div
                  className="col-12"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <button
                    class="btn  ButtonCSS"
                    type="submit"
                    onClick={(e) => {
                      HandleClick(e);
                    }}
                    style={{ background: "#234492" }}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>


      {isModalOpen === true ?
        <div className="RoleCreatePopup  ">
          <div className="BeforePopUp">
            <div className="RolePopups  User_ProfileImage"
              // isOpen={isModalOpen}
              onRequestClose={closeModal}
              contentLabel="Capture Photo"
              style={{
                content: {
                  top: "50%",
                  left: "50%",
                  right: "auto",
                  bottom: "auto",
                  marginRight: "-50%",
                  transform: "translate(-50%, -50%)",
                },
              }}
            >
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width="100%"
                height="100%"
                onUserMediaError={(error) => {
                  alert("No camera detected or access denied. Please ensure a camera is connected.");
                  console.error("Camera error:", error);
                  setIsModalOpen(false)
                }}
              />
              <div className="UserButton">
                <button
                  className="Signatures ButtonCSS"
                  onClick={capturePhoto}
                  style={{
                    marginTop: "20px",
                    background: "#234492",
                    color: "#ffff !important",
                  }}
                >
                  Capture Photo
                </button>
                <button
                  className="Signatures ButtonCSS"
                  onClick={closeModal}
                  style={{
                    marginTop: "20px",
                    marginLeft: "10px",
                    background: "#aaa",
                    color: "#ffff !important",
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        : null}


      {CroppImageView && (
        <ImageCropper
          updateAvatar={updateAvatar}
          selectedImage={UserFile}
          getCroppedImg={getCroppedImg}
          closeModal={() => setCroppImageView(false)}
        />
      )}
      {/* {notifiycationpopup && (
        <NotificationScreen  setshow={setnotificationpopus} show={notifiycationpopup}/>
      )} */}


    </>
  );
};

export default UserProfilepart;
